<template>
  <div class="additional">
    <h3>Additional</h3>
    <div class="content">
      <div class="project-item">
        <a class="project-title" href="http://codeschool.com/users/933700/" target="_blank">CodeSchool Report</a>
        <p class="project-desc">Brushing up on fundamentals when needed</p>
      </div>
      <div class="project-item">
        <a class="project-title" href="https://github.com/cygri/pubby/pull/22/" target="_blank">Open Source Pubby Project</a>
        <p class="project-desc">UI/UX updates to the Pubby Project.</p>
      </div>
      <div class="project-item">
        <a class="project-title">Certified Scuba Diver</a>
        <p class="project-desc">My love for water</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'additional',
  };
</script>


// WEBPACK FOOTER //
// Additional.vue?ed5d8b42